.field {
  background-color: transparent;
  appearance: none;
  min-width: 100px;
  flex: 1;
  border: 0;
  font-size: inherit;
  height: 1.6em;
  color: inherit;
  padding: 0;

  &::placeholder {
    color: var(--input-placeholder-color);
    opacity: 1;
  }

  &:where([data-type='hidden'], [data-type='auto']) {
    height: 1px;
    width: 1px;
    top: 0;
    left: 0;
    pointer-events: none;
    position: absolute;
    opacity: 0;
  }

  &:focus {
    outline: none;
  }

  &:where([data-type='auto']:focus) {
    height: 1.6em;
    visibility: visible;
    opacity: 1;
    position: static;
  }

  &:where([data-pointer]:not([data-disabled], :disabled)) {
    cursor: pointer;
  }

  &:where([data-disabled], :disabled) {
    cursor: not-allowed;
  }
}
